// extracted by mini-css-extract-plugin
export default {"box":"file-pdf_box__LLOpu","download":"file-pdf_download__qp2wV","pdfIcon":"file-pdf_pdfIcon__uBrIb"};